<template>
  <div class="relative">
    <div>
      <div class="mb-1 d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div>
            <b>Add Crew Members</b>
          </div>
        </div>
        <Checkbox
          v-model="showAll"
          label="View all Crew Members"
          class="all-techs whitespace-nowrap"
        ></Checkbox>
      </div>
      <div class="d-flex">
        <Select
          v-model="selectedCrew"
          placeholder="Search and Select to Add Crew Members"
          :options="filteredOptions"
          class="full-width"
          full-width
          search
        >
          <template #item-row="{ option }">
            <div class="option-row">
              <department-icon
                v-if="option.value && !isSameDepartment(option)"
                :department="option.department"
              />
              <truncate-text
                class="ml-1"
                :class="{ 'strike-through': option.archived }"
                :text="option.label"
              ></truncate-text>
            </div>
          </template>
        </Select>
        <Button
          text="Add"
          class="ml-2"
          :disabled="!selectedCrew"
          @click="addCrewMember"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Button from "@/components/Button.vue";
import Checkbox from "@/components/Checkbox.vue";
import DepartmentIcon from "@/components/DepartmentIcon.vue";
import TruncateText from "@/components/TruncateText.vue";

export default {
  components: {
    Button,
    DepartmentIcon,
    TruncateText,
    Checkbox
  },
  props: {
    crewMembers: {
      type: Array,
      default: () => []
    },
    fetchLink: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["add-crew"],
  data() {
    return {
      showAll: false,
      selectedCrew: null,
      options: []
    };
  },
  computed: {
    ...mapState({
      departmentId: ({ job }) => {
        return job.department ? job.department.id : -1;
      },
      crewsFromStore: "crewMembers"
    }),
    filteredOptions() {
      return this.showAll
        ? this.options
        : this.options.filter(
            (option) => option.department.id === this.departmentId
          );
    }
  },
  mounted() {
    this.fetchCrewOptions();
  },
  methods: {
    ...mapActions(["fetchCrewMembers"]),
    addCrewMember() {
      const selectedOption = this.options.find(
        (option) => this.selectedCrew === option.id
      );
      this.$emit("add-crew", selectedOption);
      this.selectedCrew = null;
    },
    fetchCrewOptions() {
      if (this.crewsFromStore.length > 0) {
        this.options = this.parseToOptions(this.crewsFromStore);
        return;
      }
      this.fetchCrewMembers({
        link: this.fetchLink
      }).then((res) => {
        this.options = this.parseToOptions(res.data);
      });
    },
    parseToOptions(data) {
      return data.map((member) => {
        return {
          ...member,
          label: member.full_name,
          value: member.id
        };
      });
    },
    isSameDepartment(option) {
      return option.department
        ? option.department.id === this.departmentId
        : false;
    }
  }
};
</script>

<style lang="scss" scoped>
.all-techs {
  font-size: 0.9em;
}

.crew-option-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.custom-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: var(--font-color);
}

.option-row {
  display: flex;
  align-items: center;
  width: 100%;
}
</style>
